import { useId } from 'react'

interface HelpTextProps {
  helpTextId?: string
  helpText?: string
  errorText?: string
  disabledText?: string
}

/**
 * Custom hook to manage helpTextId generation and conditional usage.
 *
 * @param props - Object containing helpTextId, helpText, errorText, disabledText
 * @returns The helpTextId to use (provided custom ID, generated ID if help text exists, or undefined)
 */
export function useHelpTextId(props?: HelpTextProps): string | undefined {
  const { helpTextId, helpText, errorText, disabledText } = props || {}
  const generatedHelpTextId = useId()

  // If a helpTextId is explicitly provided, use it
  if (helpTextId) {
    return helpTextId
  }

  // Only use generated helpTextId if help text content exists
  const hasHelpContent = !!(helpText || errorText || disabledText)

  return hasHelpContent ? generatedHelpTextId : undefined
}
